/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const TERMS_OF_SERVICE_URL = `${process.env.SN_KB_EXT_URL}/en/terms-of-service?id=kb_article&sysparm_article=KB0012294`;
export const FOIA_URL = `${process.env.SN_KB_EXT_URL}/en/freedom-of-information-act?id=kb_article&sysparm_article=KB0011973`;
export const PRIVACY_POLICY_URL = `${process.env.SN_KB_EXT_URL}/en/privacy-policy?id=kb_article&sysparm_article=KB0011971`;

// cSpell:ignore sysparm
